import { registerEnumType } from 'type-graphql'

export enum ComplexEditorLayoutChoiceEnum {
  POPOVER = 'POPOVER',
  INLINE = 'INLINE',
}

registerEnumType(ComplexEditorLayoutChoiceEnum, {
  name: 'ComplexEditorLayoutChoiceEnum',
  description: 'Available complex editor layout choices',
})

export const ComplexEditorLayoutChoiceMetadata = {
  [ComplexEditorLayoutChoiceEnum.POPOVER]: {
    name: 'Popover',
    description:
      'Edits open in a non-modal card anchored to the field being edited, leaving the page beneath undisturbed',
  },
  [ComplexEditorLayoutChoiceEnum.INLINE]: {
    name: 'Inline',
    description: 'Edits open in the page flow where the field was rendered, pushing the content below it down the page',
  },
}
